<template>
  <div id="app" :class="styles">
    <Loader v-if="isFetching" />
    <template v-else>
      <router-view />
      <portal-target name="modal" />
    </template>
  </div>
</template>

<script>
import Loader from "./components/loader/Loader";

export default {
  components: {
    Loader
  },

  props: {
    showContentRibbon: {
      type: Boolean,
      default: false
    },
    addExtraSpace: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isFetching: true
    };
  },

  computed: {
    styles() {
      return {
        app: true,
        [`app--${this.$route.name}`]: true,
        "app--loading": this.isFetching,
        "app--content-ribbon": this.showContentRibbon,
        "add-extra-space": this.addExtraSpace
      };
    }
  },

  created() {
    // Remove the meta tags from template if oading in browser
    // To replace with values from vue-head
    if (document.querySelector("meta[property='og:title']")) {
      const titleEL = document.querySelector("meta[property='og:title']");
      titleEL.parentNode.removeChild(titleEL);
    }

    if (document.querySelector("meta[property='og:image']")) {
      const imageEl = document.querySelector("meta[property='og:image']");
      imageEl.parentNode.removeChild(imageEl);
    }

    if (document.querySelector("meta[property='og:description']")) {
      const descEl = document.querySelector("meta[property='og:description']");
      descEl.parentNode.removeChild(descEl);
    }

    if (document.querySelector("meta[property='og:image:width']")) {
      const imgWidthEl = document.querySelector("meta[property='og:image:width']");
      imgWidthEl.parentNode.removeChild(imgWidthEl);
    }

    if (document.querySelector("meta[property='og:image:height']")) {
      const imgHeightEl = document.querySelector("meta[property='og:image:height']");
      imgHeightEl.parentNode.removeChild(imgHeightEl);
    }

    this.$store
      .dispatch("syncRegions")
      .then(() => this.$store.dispatch("syncForecasts"))
      .then(() => this.$store.dispatch("syncCmsData"))
      .then(() => this.$store.dispatch("syncNotificationData"))
      .then(() => this.$store.dispatch("syncRecaptchaKey"))
      .then(() => this.$store.dispatch("syncObservations"))
      .then(() => {
        this.isFetching = false;
      })
      .catch(error => {
        console.log(error);
      });
  }
};
</script>
